import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
export var useCaptchaInput = function useCaptchaInput(_ref) {
  var isError = _ref.isError,
    errorText = _ref.errorText,
    handleErrorStatus = _ref.handleErrorStatus,
    onChange = _ref.onChange,
    onRefresh = _ref.onRefresh;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setCaptchaValue = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var inputRef = useRef(null);
  useEffect(function () {
    if (inputRef.current && isError) {
      inputRef.current.focus();
      setErrorMessage(errorText || '');
      handleErrorStatus === null || handleErrorStatus === void 0 || handleErrorStatus(true);
      setCaptchaValue('');
    }
  }, [isError]);
  var handleBlur = function handleBlur() {
    if (value.length < 5) {
      setErrorMessage(errorText || '');
      handleErrorStatus === null || handleErrorStatus === void 0 || handleErrorStatus(true);
    }
    if (isError) handleErrorStatus === null || handleErrorStatus === void 0 || handleErrorStatus(true);
  };
  var handleFocus = function handleFocus() {
    if (value.length > 1) {
      setErrorMessage('');
      handleErrorStatus === null || handleErrorStatus === void 0 || handleErrorStatus(false);
    }
  };
  var handleChange = function handleChange(e) {
    var inputValue = e.target.value;
    if (inputValue.length === 5) handleErrorStatus === null || handleErrorStatus === void 0 || handleErrorStatus(false);
    if (inputValue.length > 5) return;
    setCaptchaValue(inputValue);
    onChange === null || onChange === void 0 || onChange(inputValue);
  };
  var handleRefresh = function handleRefresh(e) {
    e.preventDefault();
    setCaptchaValue('');
    onRefresh === null || onRefresh === void 0 || onRefresh();
  };
  return {
    inputRef: inputRef,
    handleBlur: handleBlur,
    handleFocus: handleFocus,
    errorMessage: errorMessage,
    handleChange: handleChange,
    handleRefresh: handleRefresh,
    value: value
  };
};